import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'
import echarts from 'echarts'
import Schart from 'vue-schart'
import './components/common/directives'
import './assets/css/icon.css';
import 'babel-polyfill';
import { initMenu } from './utils/menu'
import { getRequest } from './utils/request'
import { getToken } from '@/utils/auth'
import VueLazyLoad from 'vue-lazyload'; // 懒加载
//import './components/common/directives';
Vue.prototype.$echarts = echarts
Vue.prototype.getRequest = getRequest;

Vue.config.productionTip = false
Vue.use(Schart)
Vue.use(ElementUI);
Vue.use(VueLazyLoad);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
    if (to.path === '/' || to.redirectedFrom === '/index') {
        return next()
    }
    if ( to.path === '/login')
        return next()
    if (getToken() === undefined &&  to.path === '/m-index/hld') {
        console.log('to.query, from.query', to.query, from.query)
        return next({
            path: '/login',
            query: from.query
        })
    } if (getToken() === undefined &&  to.path.indexOf('/adaptation') > -1) {
        // console.log('to.query, from.query', to.query, from.query)
        return next({
            path: '/login',
            // query: from.query
        })
    } else {
        initMenu(router, store);
    //     // if (to.path.startsWith('/adaptation') && store.getters.roles[0] !== 'Aadmin' && store.getters.roles[0] !== 'Auser') {
    //     //     return next(from.path)
    //     // }
    //     // if (to.path.startsWith('/configuration') && store.getters.roles[0] !== 'Cadmin') {
    //     //     return next(from.path)
    //     // }
    //     // if (to.path.startsWith('/forecast') && store.getters.roles[0] !== 'Fadmin') {
    //     //     return next(from.path)
    //     // }
    //     // if (to.path.startsWith('/recommend') && store.getters.roles[0] !== 'Radmin') {
    //     //     return next(from.path)
    //     // }
        return next()
    }
})